module.exports = __webpack_public_path__ + "media/components/journeys/ticket-icons/comment-1f87883f9e4bb94f18a4b9e6810e902e.png";